export class ParametersGlobals {
  // Parâmetros Genéricos
  static useMapGoogleView: string = "http://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}";
  static perPage: number = 20;
  static projectTitle: string = "MVB";
  static urlAddressDetailCheck : string = '/dashboard/kpi/filled_checklists/view/'
  static versionActual: string = 'v1.0 '
}
